"use strict";
exports.INTERACTIONS = Object.freeze({
    BOOKED: 'booked',
    SAVED: 'saved'
});
